<!--
  - 代码运行菜单栏
-->

<template>
	<div class="widget_menu">
		<ul>
			<li :style="{color: it.color, width: it.width}" @click="submit_command(it)" v-for="(it,index) in items"
			    :class="{ 'high' : !('drop_items' in it) }" v-on:mouseenter="item_in(index)"
			    v-on:mouseleave="item_out(index)">
				<i class="fa" :class="it.icon"></i>
				{{it.name}}
				<dropItem v-if="'drop_items' in it" v-show="it.drop_show" :items="it.drop_items"
				          @submit_key="submit_key"></dropItem>
			</li>
		</ul>
	</div>
</template>


<script>
	// import '@/assets/css/icon/build.css'
	import dropItem from './dropItem'
	import {mapGetters} from 'vuex'

	export default {
		name: 'widget_menu',
		data(){
			return {
				items: [
					{
						name: '打开文件',
						key: 'open',
						icon: 'fa-folder-open',
						drop_show: false,
					},
					{
						name: '保存代码',
						key: 'save',
						icon: 'fa-save',
						drop_show: false,
					},
					{
						name: '另存为',
						key: 'save_as',
						icon: 'fa-files-o',
						drop_show: false,
					},
					{
						name: '在线运行',
						key: 'run',
						icon: 'fa-play',
						drop_show: false,
					},
					{
						name: '运行语言',
						key: 'language',
						icon: 'fa-buysellads',
						drop_show: false,
						drop_items: [
							{
								'key': 'lang-php7',
								'title': 'php7',
								'select': false,
							},
							{
								'key': 'lang-python',
								'title': 'python',
								'select': false,
							},
							{
								'key': 'lang-node',
								'title': 'node',
								'select': false,
							},
							{
								'key': 'lang-golang',
								'title': 'golang',
								'select': false,
							},
							{
								'key': 'lang-shell',
								'title': 'shell',
								'select': false,
							},
							{
								'key': 'lang-lua',
								'title': 'lua',
								'select': false,
							},
							{
								'key': 'lang-perl',
								'title': 'perl',
								'select': false,
							},
							{
								'key': 'lang-c',
								'title': 'c',
								'select': false,
							},
							{
								'key': 'lang-cpp',
								'title': 'cpp',
								'select': false,
							},
							{
								'key': 'lang-java',
								'title': 'java',
								'select': false,
							},
							{
								'key': 'lang-ruby',
								'title': 'ruby',
								'select': false,
							},
						]
					},
					{
						name: '代码配色',
						key: 'theme',
						icon: 'fa-eyedropper',
						drop_show: false,
						drop_items: [
							{
								'key': 'theme-monokai',
								'title': 'monokai',
								'select': false,
							},
							{
								'key': 'theme-github',
								'title': 'github',
								'select': false,
							},
							{
								'key': 'theme-solarized_light',
								'title': 'solarized_light',
								'select': false,
							},
							{
								'key': 'theme-solarized_dark',
								'title': 'solarized_dark',
								'select': false,
							},
							{
								'key': 'theme-clouds',
								'title': 'clouds',
								'select': false,
							},
							{
								'key': 'theme-eclipse',
								'title': 'eclipse',
								'select': false,
							},
							{
								'key': 'theme-xcode',
								'title': 'xcode',
								'select': false,
							},
							{
								'key': 'theme-twilight',
								'title': 'twilight',
								'select': false,
							},
						]
					},
					{
						name: '字体大小',
						key: 'font_size',
						icon: 'fa-font',
						drop_show: false,
						drop_items: [
							{
								'key': 'size-12px',
								'title': '12px',
								'select': false,
							},
							{
								'key': 'size-14px',
								'title': '14px',
								'select': false,
							},
							{
								'key': 'size-16px',
								'title': '16px',
								'select': false,
							},
							{
								'key': 'size-18px',
								'title': '18px',
								'select': false,
							},
							{
								'key': 'size-20px',
								'title': '20px',
								'select': false,
							},
						]
					},
					{
						name: '其他设置',
						key: 'other',
						icon: 'fa-asterisk',
						drop_show: false,
						drop_items: [
							{
								'key': 'other_line_number',
								'title': '显示行号',
								'select': false,
								'group': 'line-number', // 取消分组
								'single': true, // 是否可单独取消
							},
							{
								'key': 'other_charset_visible',
								'title': '显示不可见字符',
								'select': false,
								'group': 'charset-visible',
								'single': true,
							},
							// {
							// 	'key': 'other_grammar',
							// 	'title': '语法提示',
							// 	'select': false,
							// 	'single': true,
							// },
							// {
							// 	'key': 'other_keymap_normal',
							// 	'title': '普通输入模式',
							// 	'select': false,
							// 	'group': 'keymap',
							// },
							// {
							// 	'key': 'other_keymap_vim',
							// 	'title': 'Vim模式',
							// 	'select': false,
							// 	'group': 'keymap',
							// },
							// {
							// 	'key': 'other_keymap_emacs',
							// 	'title': 'Emacs模式',
							// 	'select': false,
							// 	'group': 'keymap',
							// },
						],
					},
					{
						name: '获取分享链接',
						key: 'share',
						icon: 'fa-share-alt',
						drop_show: false,
						color: '#c95d38',
						width: '120px',
					},
				]
			};
		},
		components: {
			dropItem,
		},
		props: {},
		methods: {
			item_in(index){
				this.items[index].drop_show = true;
			},
			item_out(index){
				this.items[index].drop_show = false;
			},
			submit_key(key){
				_.each(this.items, (value, index)=>{
					value.drop_show = false;
				});

				let param = _.clone(key);
				param['type'] = param.key.split('-')[0];
				param['value'] = param.key.split('-')[1];
				this.$emit("main_run_key", param);
			},
			submit_command(item){
				this.$emit('submit_command', item.key);
			},
			ChangeMenuIcon(index, icon_name){
				this.items[index].icon = icon_name;
			},
			RefreshStatus(){
				//set editor language
				_.each(this.items[4].drop_items, (item, index)=>{
					if(item.single !== true){
						item.select = false;
					}
					if(item.title === this.editor_status.language){
						item.select = true;
					}
				});

				//set editor theme
				_.each(this.items[5].drop_items, (item, index)=>{
					if(item.single !== true){
						item.select = false;
					}
					if(item.title === this.editor_status.theme){
						item.select = true;
					}
				});

				//set editor size
				_.each(this.items[6].drop_items, (item, index)=>{
					if(item.single !== true){
						item.select = false;
					}
					if(item.title === this.editor_status.size){
						item.select = true;
					}
				});

				// set editor line-number visible
				_.each(this.items[7].drop_items, (item, index)=>{
					if(this.editor_status.line_number_visible && item.key === 'other_line_number'){
						item.select = true;
					}else if(this.editor_status.charset_visible && item.key === 'other_charset_visible'){
						item.select = true;
					}else if(this.editor_status.grammar && item.key === 'other_grammar'){
						item.select = true;
					}else if(this.editor_status.keymap === 'normal' && item.key === 'other_keymap_normal'){
						item.select = true;
					}else if(this.editor_status.keymap === 'vim' && item.key === 'other_keymap_vim'){
						item.select = true;
					}else if(this.editor_status.keymap === 'emacs' && item.key === 'other_keymap_emacs'){
						item.select = true;
					}
				});
			}
		},
		created(){
			this.RefreshStatus();
		},
		computed: {
			...mapGetters([
				'editor_status',
			]),
		},
		mounted(){
		},
		watch: {}
	}
</script>

<style scoped lang="less">
	@menu_background: #252526;
	@menu_background_light: #49483E;
	.widget_menu {
		height: 100%;
		
		ul {
			background: @menu_background;
			display: flex;
			flex-direction: row;
			color: white;
			padding: 7px 5px;
			font-weight: 600;
			
			li {
				list-style-type: none;
				padding: 1px 10px;
				cursor: pointer;
				box-sizing: border-box;
				border-bottom: 1px solid @menu_background;
				width: 90px;
				text-align: center;
			}
			
			li.high:hover {
				border-bottom: 1px solid white;
			}
		}
	}
</style>

